/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';


class LiveroomVerifyTopBar extends Component {
    constructor() {
        super();
        this.handleChangeRadio = this.handleChangeRadio.bind(this);
    }

    handleChangeRadio(e) {
        const {handleChange, status} = this.props;
        // 审核中和审核成功将不允许选择
        if (status === 'success' || status === 'review') return
        handleChange(e.target.dataset.type);
    }

    render() {
        const {selectType} = this.props;

        return (
            <div className="liveroom-verify-top-bar">
                <p className="verify-title">选择认证类型</p>
                <div className="verify-tab">
                    <label className="user" htmlFor="id_type_0">
                        <div className="user-icon icon-container pointer-none"><i className="iconfont icon-degree pointer-none"/></div>
                        <div className="pointer-none">
                            <input type="radio" id="id_type_0" name="type"
                                    checked={selectType === 'person' ? "checked" : "" }
                                    data-type="person"
                                    onChange={this.handleChangeRadio}/>
                            <span>个人认证</span>
                        </div>
                    </label>
                    <label className="organization" htmlFor="id_type_1">
                        <div className="organization-icon icon-container pointer-none"><i className="iconfont icon-jigou pointer-none"/></div>
                        <div className="pointer-none">
                            <input type="radio" name="type" id="id_type_1"
                                    checked={selectType === 'company' ? "checked" : ""}
                                    data-type="company"
                                    onChange={this.handleChangeRadio}/>
                            <span>机构认证</span>
                        </div>
                    </label>
                </div>
            </div>
        )
    }
}

export default LiveroomVerifyTopBar;


// WEBPACK FOOTER //
// ./src/components/liveroomVerify/LiveroomVerifyTopBar.js